export interface PathItem {
  [k: string]: {
    PATH: string
    LABEL: string
    BREADCRUMB: Array<string>
  }
}

export const DASHBOARD: PathItem = {
  DETAIL: { PATH: "/dashboard", LABEL: "DashBoard", BREADCRUMB: ["DashBoard"] },
}

export const PUBLIC: PathItem = {
  LOGIN: { PATH: "/login", LABEL: "Đăng nhập", BREADCRUMB: ["Đăng nhập"] },
  FORGOT_PASSWORD: { PATH: "/forgot-password", LABEL: "", BREADCRUMB: [] },
  RESET_PASSWORD: { PATH: "/reset-password", LABEL: "", BREADCRUMB: [] },
}

export const SETTINGS: PathItem = {
  LIST: { PATH: "/settings", LABEL: "List settings", BREADCRUMB: ["List settings"] },
  CREATE: { PATH: "/settings/create", LABEL: "Create Setting", BREADCRUMB: ["Create New Setting"] },
  EDIT: { PATH: "/settings", LABEL: "", BREADCRUMB: [""] },
}

export const POSTS: PathItem = {
  LIST: { PATH: "/posts", LABEL: "All Post", BREADCRUMB: ["All Post"] },
  CREATE: { PATH: "/posts/create", LABEL: "Add New Post", BREADCRUMB: ["Add"] },
  EDIT: { PATH: `/posts/edit`, LABEL: "Edit Post", BREADCRUMB: ["Edit"] },
}
export const SEOSETTING: PathItem = {
  LIST: { PATH: "/seo-setting", LABEL: "SEO", BREADCRUMB: ["SEO"] },
  EDiT: { PATH: "/seo-setting", LABEL: "Edit SEO Setting", BREADCRUMB: ["Edit"] },
}

export const MEDIA: PathItem = {
  LIST: { PATH: "/upload", LABEL: "Library", BREADCRUMB: ["Library"] },
  CREATE: { PATH: "/upload/create", LABEL: "Add New Media File", BREADCRUMB: ["Add New Media File"] },
  EDIT: { PATH: "/upload/edit", LABEL: "", BREADCRUMB: [] },
}
export const CONTACTFORM: PathItem = {
  LIST: { PATH: "/contactForm", LABEL: "All Contact Form", BREADCRUMB: ["All ConTact Form"] },
  CREATE: { PATH: "/contactForm/create", LABEL: "Add New Contact Form", BREADCRUMB: ["Add"] },
  EDIT: { PATH: `/contactForm`, LABEL: "Edit Contact", BREADCRUMB: ["Edit"] },
}
export const CATEGORIES: PathItem = {
  LIST: { PATH: "/category", LABEL: "Category", BREADCRUMB: ["All Categories"] },
  EDIT: { PATH: `/category/edit`, LABEL: "Edit Category", BREADCRUMB: ["Edit"] },
  CREATE: { PATH: `/category/create`, LABEL: "Create Category", BREADCRUMB: ["Create"] },
}
export const USERS: PathItem = {
  LIST: { PATH: "/users", LABEL: "All Users", BREADCRUMB: ["All Users"] },
  CREATE: { PATH: "/users/create", LABEL: "Create User", BREADCRUMB: ["Create New User"] },
  EDIT: { PATH: "/users/edit", LABEL: "", BREADCRUMB: ["Users Edit"] },
  PROFILE: { PATH: "/users/profile", LABEL: "Profile", BREADCRUMB: ["Profile"] },
}

export const ROLES: PathItem = {
  LIST: { PATH: "/roles", LABEL: "All Roles", BREADCRUMB: ["All Roles"] },
  CREATE: { PATH: "/roles/create", LABEL: "Create new role", BREADCRUMB: ["Create New Role"] },
  EDIT: { PATH: "/roles/edit", LABEL: "Edit Role", BREADCRUMB: ["All Roles", "Edit"] },
}
export const MENUS: PathItem = {
  DETAIL: { PATH: "/menus", LABEL: "Menus", BREADCRUMB: ["Menus"] },
  LIST: { PATH: "/menus", LABEL: "All Menus", BREADCRUMB: ["Menus"] },
  CREATE: { PATH: "/menus/create", LABEL: "Add New Menu", BREADCRUMB: ["Menus", "Add"] },
  EDIT: { PATH: "/menus/edit", LABEL: "Edit Menu", BREADCRUMB: ["Menus", "Edit"] },
}
export const PAGES: PathItem = {
  LIST: { PATH: "/pages", LABEL: "All Page", BREADCRUMB: ["All Pages"] },
  CREATE: { PATH: "/pages/create", LABEL: "Add New Page", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/pages/edit", LABEL: "Edit Page", BREADCRUMB: ["Edit"] },
}

export const PUCK: PathItem = {
  LIST: { PATH: "/ui-builder", LABEL: "UI Builder", BREADCRUMB: ["UI Builder"] },
}
export const BLOCK_CONTENT = {
  LIST: { PATH: "/block-content", LABEL: "Block Content", BREADCRUMB: ["Block Content"] },
  CREATE: { PATH: "/block-content/:id", LABEL: "Sửa Template", BREADCRUMB: ["Sửa Template"] },
}

export const GENERAL_SETTING = {
  LIST: { PATH: "/general-setting", LABEL: "General Setting", BREADCRUMB: ["General Setting"] },
}
export const BASESYSTEM: PathItem = {
  LIST: { PATH: "/bases", LABEL: "All Base", BREADCRUMB: ["BASES"] },
  CREATE: { PATH: "/bases/create", LABEL: "Add New Base", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/bases/edit", LABEL: "Edit Base", BREADCRUMB: ["Edit"] },
}

export const TOURS: PathItem = {
  LIST: { PATH: "/tours", LABEL: "All Tours", BREADCRUMB: ["All Tours"] },
  CREATE: { PATH: "/tours/create", LABEL: "Add New Tour", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/tours/edit", LABEL: "Edit Tour", BREADCRUMB: ["Edit"] },
}

export const TAGS: PathItem = {
  LIST: { PATH: "/tags", LABEL: "All Tags", BREADCRUMB: ["All Tags"] },
  CREATE: { PATH: "/tags/create", LABEL: "Add New Tag", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/tags/edit", LABEL: "Edit Tag", BREADCRUMB: ["Edit Tag"] },
}

export const DESTINATIONS: PathItem = {
  LIST: { PATH: "/destinations", LABEL: "All Destinations", BREADCRUMB: ["All Destinations"] },
  CREATE: { PATH: "/destinations/create", LABEL: "Add New Destination", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/destinations/edit", LABEL: "Edit Destination", BREADCRUMB: ["Edit"] },
}

export const EVENTS: PathItem = {
  LIST: { PATH: "/events", LABEL: "All Events", BREADCRUMB: ["All Events"] },
  CREATE: { PATH: "/events/create", LABEL: "Add New Event", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/events/edit", LABEL: "Edit Event", BREADCRUMB: ["Edit"] },
}

export const EVENT_SUBSCRIBERS: PathItem = {
  LIST: { PATH: "/subscriber", LABEL: "All Event Subscribers", BREADCRUMB: ["All Event Subscribers"] },
  CREATE: { PATH: "/subscriber/create", LABEL: "Add New Event Subscriber", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/subscriber/edit", LABEL: "Edit Event Subscribers", BREADCRUMB: ["Edit"] },
}

export const CUSTOMERS: PathItem = {
  LIST: { PATH: "/customer", LABEL: "All Customers", BREADCRUMB: ["All Customers"] },
  CREATE: { PATH: "/customer/create", LABEL: "Add New Customer", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/customer/edit", LABEL: "Edit Customer", BREADCRUMB: ["Edit"] },
}

export const CAREER_FORM: PathItem = {
  LIST: { PATH: "/career-form", LABEL: "All Career Form", BREADCRUMB: ["All Career Form"] },
  CREATE: { PATH: "/career-form/create", LABEL: "Add New Career Form", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/career-form/edit", LABEL: "Edit Career Form", BREADCRUMB: ["Edit"] },
}

export const CAMPAIGN_SUBSCRIBERS: PathItem = {
  LIST: { PATH: "/campaign-subscribers", LABEL: "All Campaign Subscribers", BREADCRUMB: ["All Campaign Subscribers"] },
  CREATE: {
    PATH: "/campaign-subscribers/create",
    LABEL: "Add New Campaign Subscriber",
    BREADCRUMB: ["Add"],
  },
  EDIT: { PATH: "/campaign-subscribers/edit", LABEL: "Edit Campaign Subscriber", BREADCRUMB: ["Edit"] },
}

export const CAMPAIGNS: PathItem = {
  LIST: { PATH: "/campaigns", LABEL: "All Campaigns", BREADCRUMB: ["All Campaigns"] },
  CREATE: { PATH: "/campaigns/create", LABEL: "Add New Campaign", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/campaigns/edit", LABEL: "Edit Campaign", BREADCRUMB: ["Edit"] },
}

export const LETAKY: PathItem = {
  LIST: { PATH: "/letaky", LABEL: "All Letaky", BREADCRUMB: ["All Letaky"] },
  CREATE: { PATH: "/letaky/create", LABEL: "Add New Letaky", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/letaky/edit", LABEL: "Edit Letaky", BREADCRUMB: ["Edit"] },
}

export const BANNERS: PathItem = {
  LIST: { PATH: "/banners", LABEL: "All Banners", BREADCRUMB: ["All Banners"] },
  CREATE: { PATH: "/banners/create", LABEL: "Add New Banner", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/banners/edit", LABEL: "Edit Banner", BREADCRUMB: ["Edit"] },
}

export const VIDEO: PathItem = {
  LIST: { PATH: "/video", LABEL: "All Video", BREADCRUMB: ["All Video"] },
  CREATE: { PATH: "/video/create", LABEL: "Add New Video", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/video/edit", LABEL: "Edit Video", BREADCRUMB: ["Edit"] },
}

export const YOUTUBE_VIDEO: PathItem = {
  LIST: { PATH: "/youtube-videos", LABEL: "All YouTube Videos", BREADCRUMB: ["All YouTube Videos"] },
  CREATE: { PATH: "/youtube-videos/create", LABEL: "Add New YouTube Video", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/youtube-videos/edit", LABEL: "Edit YouTube Video", BREADCRUMB: ["Edit"] },
}

export const SETTINGS_TAMDAMEDIA: PathItem = {
  LIST: { PATH: "/tamda-media-settings", LABEL: "Tamda Media Settings", BREADCRUMB: ["Tamda Media Settings"] },
}

export const SETTINGS_TAMDAONE: PathItem = {
  LIST: { PATH: "/tamda-one-settings", LABEL: "Tamda One Settings", BREADCRUMB: ["Tamda One Settings"] },
}

export const CAREERS: PathItem = {
  LIST: { PATH: "/careers", LABEL: "Tất cả Tin tuyển dụng", BREADCRUMB: ["Tất cả Tin tuyển dụng"] },
  CREATE: { PATH: "/careers/create", LABEL: "Thêm Tin tuyển dụng", BREADCRUMB: ["Thêm Tin tuyển dụng"] },
  EDIT: { PATH: "/careers/edit", LABEL: "Sửa Tin tuyển dụng", BREADCRUMB: ["Sửa Tin tuyển dụng"] },
}

export const STORES: PathItem = {
  LIST: { PATH: "/stores", LABEL: "Tất cả Cửa hàng", BREADCRUMB: ["Tất cả Cửa hàng"] },
  CREATE: { PATH: "/stores/create", LABEL: "Thêm Cửa hàng", BREADCRUMB: ["Thêm Cửa hàng"] },
  EDIT: { PATH: "/stores/edit", LABEL: "Sửa Cửa hàng", BREADCRUMB: ["Sửa Cửa hàng"] },
}

export const CONTACT_FORMS: PathItem = {
  LIST: { PATH: "/contact-forms", LABEL: "All Contact Forms", BREADCRUMB: ["All Contact Forms"] },
  CREATE: { PATH: "/contact-forms/create", LABEL: "Add New Contact Form", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/contact-forms/edit", LABEL: "Edit Contact Form", BREADCRUMB: ["Edit"] },
}

export const SUPPLIERS: PathItem = {
  LIST: { PATH: "/suppliers", LABEL: "Tất cả nhà cung cấp", BREADCRUMB: ["Tất cả nhà cung cấp"] },
  CREATE: { PATH: "/suppliers/create", LABEL: "Thêm nhà cung cấp", BREADCRUMB: ["Thêm nhà cung cấp"] },
  EDIT: { PATH: "/suppliers/edit", LABEL: "Sửa nhà cung cấp", BREADCRUMB: ["Sửa nhà cung cấp"] },
}

export const WEBSITES: PathItem = {
  LIST: { PATH: "/websites", LABEL: "All Websites", BREADCRUMB: ["All Websites"] },
  CREATE: { PATH: "/websites/create", LABEL: "Add New Website", BREADCRUMB: ["Add"] },
  EDIT: { PATH: "/websites/edit", LABEL: "Edit Website", BREADCRUMB: ["Edit"] },
}

export const TRANSLATIONS: PathItem = {
  LIST: { PATH: "/translations", LABEL: "Danh sách bản dịch", BREADCRUMB: ["Bản dịch"] },
  CREATE: { PATH: "/translations/create", LABEL: "Tạo bản dịch", BREADCRUMB: ["Bản dịch", "Tạo mới"] },
  EDIT: { PATH: "/translations/edit", LABEL: "Chỉnh sửa bản dịch", BREADCRUMB: ["Bản dịch", "Chỉnh sửa"] },
}

export const REDIS_CACHE: PathItem = {
  ALL: { PATH: "/flush-all", LABEL: "Làm mới toàn bộ dữ liệu", BREADCRUMB: ["Làm mới toàn bộ dữ liệu"] },
  BY_CONTENT_TYPE: { PATH: "/flush/", LABEL: "Làm mới một thành phần", BREADCRUMB: ["Làm mới một thành phần"] },
  BY_MULTI_CONTENT_TYPE: {
    PATH: "/flush-multiple",
    LABEL: "Làm mới nhiều thành phần",
    BREADCRUMB: ["Làm mới nhiều thành phần"],
  },
}
